(function () {
  const ROUTE_MODAL_SELECTOR = '.route-modal[data-testid="route-modal"]';
  const DRAWER_SELECTOR = '#slideout-ajax-cart';
  const CLOSE_SELECTOR = '.route-modal__close';

  let drawerObserverAttached = false;
  let isClosingRouteModal = false;
  const patchedModals = new WeakSet();

  function getRouteModal() {
    const modals = document.querySelectorAll(ROUTE_MODAL_SELECTOR);
    if (modals.length === 0) return null;
    if (modals.length === 1) return modals[0];

    // Prefer the one that's actually open; fall back to the last one in DOM order
    for (const m of modals) {
      if (m.classList.contains('rm-open')) return m;
    }
    return modals[modals.length - 1];
  }

  function getAllRouteModals() {
    return document.querySelectorAll(ROUTE_MODAL_SELECTOR);
  }

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function shouldBeOpen(rm) {
    return rm.classList.contains('rm-open');
  }

  function setDrawerPopoverMode(mode) {
    const drawer = getDrawer();
    if (drawer) drawer.setAttribute('popover', mode);
  }

  function ensurePopoverStateMatchesRoute(rm) {
    if (!rm || typeof rm.showPopover !== 'function') return;
    if (isClosingRouteModal) return;

    const open = shouldBeOpen(rm);
    const isPopoverOpen = typeof rm.matches === 'function' && rm.matches(':popover-open');

    // Correct Route's own aria-hidden mistake when we're actually open
    if (open && rm.getAttribute('aria-hidden') === 'true') {
      rm.setAttribute('aria-hidden', 'false');
    }

    if (open && !isPopoverOpen) {
      rm.setAttribute('popover', 'manual');
      rm.showPopover();
    } else if (!open && isPopoverOpen && typeof rm.hidePopover === 'function') {
      rm.hidePopover();
    }
  }

  function bringRouteModalToTop() {
    const rm = getRouteModal();
    if (!rm) return false;
    if (isClosingRouteModal) return true;

    ensurePopoverStateMatchesRoute(rm);

    if (!shouldBeOpen(rm)) {
      // Route modal is closed — safe to let the drawer light-dismiss normally again
      setDrawerPopoverMode('auto');
      return true;
    }

    // Route modal is open — lock the drawer so clicks on the modal/close button
    // can't light-dismiss the drawer underneath it.
    setDrawerPopoverMode('manual');

    if (typeof rm.showPopover === 'function') {
      rm.setAttribute('popover', 'manual');
      if (typeof rm.hidePopover === 'function') rm.hidePopover();
      rm.showPopover();
    } else {
      rm.style.position = 'fixed';
      rm.style.inset = '0';
      rm.style.zIndex = '2147483647';
    }

    return true;
  }

  function attachDrawerObserverOnce() {
    if (drawerObserverAttached) return;

    const drawer = getDrawer();
    if (!drawer) return;

    const obs = new MutationObserver(() => bringRouteModalToTop());
    obs.observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'popover-open', 'class'],
    });

    drawerObserverAttached = true;
  }

  function patchRouteModal(rm) {
    if (!rm || patchedModals.has(rm)) return false;

    patchedModals.add(rm);

    rm.addEventListener(
      'click',
      (e) => {
        const closeBtn = e.target.closest(CLOSE_SELECTOR);
        if (!closeBtn) return;

        // Let Route's own close logic run normally — do NOT preventDefault/stop here.
        isClosingRouteModal = true;

        setTimeout(() => {
          isClosingRouteModal = false;
          setDrawerPopoverMode('auto');
        }, 250);
      },
      true
    );

    if (typeof MutationObserver !== 'undefined') {
      const rmObs = new MutationObserver(() => ensurePopoverStateMatchesRoute(rm));
      rmObs.observe(rm, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    }

    return true;
  }

  function patchAllRouteModals() {
    getAllRouteModals().forEach((rm) => patchRouteModal(rm));
  }

  function removeDuplicateModals() {
    const modals = getAllRouteModals();
    if (modals.length <= 1) return;

    // Keep the open one (or the last in DOM order if none report open),
    // remove the rest so only one instance exists at a time.
    let keep = null;
    modals.forEach((m) => {
      if (m.classList.contains('rm-open')) keep = m;
    });
    if (!keep) keep = modals[modals.length - 1];

    modals.forEach((m) => {
      if (m !== keep) m.remove();
    });
  }

  function runWithRetries() {
    removeDuplicateModals();
    bringRouteModalToTop();
    attachDrawerObserverOnce();
    patchAllRouteModals();

    [500, 1000, 2000, 3000, 4000, 5000].forEach((ms) => {
      setTimeout(() => {
        removeDuplicateModals();
        bringRouteModalToTop();
        attachDrawerObserverOnce();
        patchAllRouteModals();
      }, ms);
    });
  }

  // Watch the whole document for new Route modals being added, so duplicates
  // get cleaned up / patched as soon as they appear, not just on the retry schedule.
  if (typeof MutationObserver !== 'undefined') {
    const bodyObserver = new MutationObserver(() => {
      removeDuplicateModals();
      patchAllRouteModals();
    });
    bodyObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'complete') runWithRetries();
  else window.addEventListener('load', runWithRetries, { once: true });
})();